module.exports = __webpack_public_path__ + "static/img/ubank.7ce1f31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/ubank.jpg
// module id = SEwk
// module chunks = 6